export const APP_INITIALIZED = 'app/APP_INITIALIZED';
